import type dayjs from "dayjs";

export type VoucherKind = "SalesInvoice" | "PurchaseInvoice" | "ReceiptVoucher" | "PaymentVoucher" | "JournalEntry";

export type BillEntryRow = {
  id?: number;
  billNo?: string;
  billDate?: string;
  dueDate?: string;
  partyName?: string;
  voucherType?: VoucherKind | string;
  invoiceType?: string;
  ledgerName?: string;
  grandTotal?: number;
  totalAmount?: number;
  taxableAmount?: number;
  billAttachmentCount?: number;
  voucherAttachmentCount?: number;
  referenceNo?: string;
  isPosted?: boolean;
  isDeleted?: boolean;
  deletedAt?: string;
  deletedBy?: string;
};

export type FilterState = {
  search?: string;
  billNo?: string;
  voucherType?: VoucherKind;
  isPosted?: boolean;
  dateRange?: [dayjs.Dayjs, dayjs.Dayjs] | null;
};

export type EmailPreview = {
  to?: string;
  subject?: string;
  body?: string;
  billCount?: number;
  billNos?: string[];
};

export const voucherOptions: { value: VoucherKind; label: string }[] = [
  { value: "SalesInvoice", label: "Sales Invoice" },
  { value: "PurchaseInvoice", label: "Purchase Invoice" },
  { value: "ReceiptVoucher", label: "Receipt Voucher" },
  { value: "PaymentVoucher", label: "Payment Voucher" },
  { value: "JournalEntry", label: "Journal Entry" }
];

export function voucherLabel(value?: string) {
  return voucherOptions.find((x) => x.value === value)?.label ?? value ?? "Voucher";
}
